import React, { SyntheticEvent } from 'react';

import { FastField, FieldAttributes, FieldProps } from 'formik';
import { useCampoFormularioProps } from 'service/restricao/useCampoFormularioProps/useCampoFormularioProps';
import { LoadingTexto } from '../Tipografia/Texto';
import { RadioGroup } from '@atlaskit/radio';
import { OptionsPropType } from '@atlaskit/radio/dist/types/types';
import styled from 'styled-components';


interface NotasAvaliacaoFieldProps extends FieldAttributes<any>{
  name: string
}

export const NotasAvaliacaoField: React.FC<NotasAvaliacaoFieldProps> = ({name, ...props}) => {
  const restricoesProps = useCampoFormularioProps(name);

  var items: OptionsPropType = [];
  for (let i = 1; i<= 10; i++) {
    items.push({name: name, value: `${i}`, label: `${i}`});
  }

  if (restricoesProps.hidden) {
    return <></>
  }

  if (restricoesProps.loading) {
    return <LoadingTexto width={120} />
  }

  return <RadioContainerStlyed>
    <FastField {...props}>{
      ({form}: FieldProps) => {
        const onChange = (event: SyntheticEvent<HTMLInputElement>) => {
          form.setFieldValue("notaAvaliacao", event.currentTarget.value)
        }

        return <RadioGroup
          options={items}
          onChange={onChange}
          isRequired={true}
        />
      }
    }</FastField>
  </RadioContainerStlyed>
}

const RadioContainerStlyed = styled.div`
  label {
    display: inline-block;
    text-align: center;
    margin-top: 0;
  }
`;
